import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {
  ApGridMultiSelectComponent
}                                                                                    from '../../ap-core/components/ap-grid-multi-select/ap-grid-multi-select.component';
import {ApGridPagerType, IGridPagerData, IWizardChoiceData, IWizardChoiceDataValue}  from '../../ap-interface';
import {
  ApDynformsConfigFieldset
}                                                                                    from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigTabs
}                                                                                    from '../../ap-dynforms/config/ap-dynforms-config-tabs';
import {
  PagerIconButton
}                                                                                    from '../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {
  ItemDisabledFn
}                                                                                    from '@progress/kendo-angular-dropdowns';
import {BehaviorSubject, Observable}                                                 from 'rxjs';
import {APP_CONFIGURATION}                                                           from '../../ap-core/config';
import {
  ApDynformsValidator
}                                                                                    from '../../ap-dynforms/ap-dynforms-validator';
import {ValidatorFn}                                                                 from '@angular/forms';
import {
  ApKendoIconService
}                                                                                    from '../../icons/ap-kendo-icon.service';

@Component({
  selector: 'ap-crop-rotation-grid-pager',
  templateUrl: './pager.component.html',
  styleUrls: ['pager.component.scss'],
})
export class PagerComponent implements OnChanges {
  protected readonly ApKendoIconService = ApKendoIconService;
  @ViewChild('gridMultiSelectComponent', {static: false}) gridMultiSelect: ApGridMultiSelectComponent;

  public selectedColumn: IWizardChoiceData;
  public selectedValue: IWizardChoiceDataValue;
  public type: ApGridPagerType;
  public numOfPages = 0;
  public buttonCountOffset = 0;
  public dimensions: number[] = [1];

  @Input() public formConfig: ApDynformsConfigFieldset[] | ApDynformsConfigTabs[] = null;
  @Input() public formValidators: ApDynformsValidator<ValidatorFn>[];
  @Input() public formDefaultValue = {};
  @Input() public currentPage = 0;
  @Input() public objects: Observable<IWizardChoiceData[]>;
  @Input() public values: IWizardChoiceDataValue[];
  @Input() public showOnlyValues = true;
  @Input() public hasMultiSelect = true;
  @Input() public showWithoutSelection = false;
  @Input() public showDefaultValue = true;
  @Input() public selectedKeys: any[];
  @Input() public pageSize = 25;
  @Input() public itemCount = 0;
  @Input() public preselect = true;
  @Input() public buttonCount = 3;
  @Input() public iconButtons: PagerIconButton[];
  @Output() public formValueChanges = new EventEmitter<{ control: string, value: any }>(true);
  @Output() public applyClicked = new EventEmitter<IGridPagerData>();
  @Output() public deleteClicked = new EventEmitter();
  @Output() public currentPageChange = new EventEmitter<number>();
  @Output() public startMultiSelectInAnimation = new EventEmitter();
  @Output() public endMultiSelectInAnimation = new EventEmitter();
  @Output() public startMultiSelectOutAnimation = new EventEmitter();
  @Output() public endMultiSelectOutAnimation = new EventEmitter();
  @Output() public selectedColumnChange = new EventEmitter<IWizardChoiceData>();
  @Output() public selectedValueChange = new EventEmitter<IWizardChoiceDataValue>();
  @Output() public pageSizeChanged = new BehaviorSubject<number>(APP_CONFIGURATION.GridPageSize);

  contextChanges = new BehaviorSubject<{ total: number, skip: number, pageSize: number }>({
    pageSize: this.pageSize,
    skip: this.currentPage * this.pageSize,
    total: this.itemCount
  });

  contextService = {
    total: this.itemCount,
    skip: this.pageSize * this.currentPage,
    pageSize: this.pageSize,
    changes: this.contextChanges,
    changePage: (page: number) => this.changePage(page + 1),
  };

  @Input() public columnItemDisabled: ItemDisabledFn = () => false;
  @Input() public valueItemDisabled: ItemDisabledFn = () => false;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.itemCount) {
      this.getDimensions();
    }

    if (changes.itemCount || changes.pageSize || changes.currentPage) {
      this.contextChanges.next({
        pageSize: this.pageSize,
        skip: (this.currentPage - 1) * this.pageSize,
        total: this.itemCount
      });
    }
  }

  changePage(page: number): boolean {
    this.buttonCountOffset = (Math.floor(page / this.buttonCount) * this.buttonCount);
    this.currentPageChange.emit(page);
    this.getDimensions();
    return false;
  }

  onSelectedColumnChange(e: IWizardChoiceData): void {
    this.selectedColumn = e || null;
    this.selectedColumnChange.emit(e);
  }

  onSelectedValueChange(e: IWizardChoiceDataValue): void {
    this.selectedValue = e || null;
    this.selectedValueChange.emit(e);
  }

  private getDimensions(): void {
    if (this.itemCount < 1 || this.pageSize < 1) {
      return;
    }
    this.numOfPages = Math.ceil(this.itemCount / this.pageSize);
    const tmp = [];
    for (let i = this.buttonCountOffset; i < this.numOfPages; i++) {
      tmp.push(i + 1);
      if (tmp.length === this.buttonCount) {
        break;
      }
    }
    this.dimensions = tmp;
  }

  public onPageSizeChanged(pageSize: number): void {
    this.pageSizeChanged.next(pageSize);
  }
}
